(() => {
  const init = () => {
    const root = document.getElementById('yumore-b2b-live');
    const config = document.getElementById('YumoreContactMessages');
    const form = root?.querySelector('#ContactForm');
    const dialog = root?.querySelector('.yb-dialog');
    const quote = root?.querySelector('.yb-quote');
    if (!form || !dialog || !quote || !config || form.dataset.yumoreContactReady) return;
    const messages = JSON.parse(config.textContent);
    form.dataset.yumoreContactReady = 'true';
    const button = form.querySelector('.yb-send');
    const sendLabel = button.textContent;
    const fields = [...form.querySelectorAll('.yb-form-grid input, .yb-form-grid textarea')];
    const nameField = form.querySelector('#yb-name');
    if (nameField) {
      nameField.required = true;
      const label = nameField.closest('label');
      if (label?.firstChild?.nodeType === Node.TEXT_NODE && !label.firstChild.textContent.includes('*')) {
        label.firstChild.textContent = label.firstChild.textContent.trimEnd() + ' *';
      }
    }
    const phoneField = form.querySelector('#yb-whatsapp');
    if (phoneField) {
      const label = phoneField.closest('label');
      if (label?.firstChild?.nodeType === Node.TEXT_NODE) label.firstChild.textContent = 'Your WhatsApp / phone *';
      phoneField.placeholder = '+';
    }
    const fieldErrors = new Map(fields.map(field => {
      const error = document.createElement('span');
      error.className = 'yb-field-error';
      error.id = field.id + '-error';
      error.hidden = true;
      field.insertAdjacentElement('afterend', error);
      const describedBy = field.getAttribute('aria-describedby');
      field.setAttribute('aria-describedby', [describedBy, error.id].filter(Boolean).join(' '));
      return [field, error];
    }));
    const renderFieldError = field => {
      const error = fieldErrors.get(field);
      const invalid = !field.validity.valid;
      error.textContent = invalid ? (field.validity.valueMissing ? 'Please fill out this field.' : field.type === 'email' ? 'Please enter a valid email address.' : field === phoneField ? 'Please enter digits only.' : 'Please check this field.') : '';
      error.hidden = !invalid;
      if (invalid) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    };
    const result = form.querySelector('[data-yumore-contact-result]')?.value;
    const storageKey = `yumore-contact:${location.pathname}`;
    let pending = false;
    let timer;
    let background = [];
    const portal = document.createElement('div');
    portal.className = 'yb-contact-portal';
    portal.hidden = true;
    document.body.append(portal);
    portal.append(dialog);
    dialog.setAttribute('aria-labelledby', 'yb-contact-heading');
    dialog.querySelector('.yb-close').setAttribute('aria-label', messages.close);
    const status = document.createElement('p');
    status.className = 'yb-submit-status';
    status.id = 'yb-submit-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.tabIndex = -1;
    button.insertAdjacentElement('afterend', status);
    button.setAttribute('aria-describedby', status.id);
    form.querySelectorAll('.form-status, .form__message, .form-status-list').forEach(node => node.remove());
    const setStatus = (state, text) => {
      status.dataset.state = state;
      status.textContent = text;
    };
    const successPanel = document.createElement('div');
    successPanel.className = 'yb-success-panel';
    successPanel.hidden = true;
    const successMessage = document.createElement('p');
    successMessage.id = 'yb-success-message';
    successMessage.textContent = 'Thank you for reaching out. We will contact you as soon as possible!';
    successMessage.tabIndex = -1;
    successMessage.setAttribute('role', 'status');
    const successClose = document.createElement('button');
    successClose.type = 'button';
    successClose.className = 'yb-success-close';
    successClose.textContent = 'Close';
    successPanel.append(successMessage, successClose);
    dialog.append(successPanel);
    const heading = dialog.querySelector('#yb-contact-heading');
    const resetSuccess = () => {
      form.hidden = false;
      heading.hidden = false;
      successPanel.hidden = true;
      delete dialog.dataset.state;
      dialog.setAttribute('aria-labelledby', heading.id);
    };
    const showSuccess = () => {
      form.hidden = true;
      heading.hidden = true;
      successPanel.hidden = false;
      dialog.dataset.state = 'success';
      dialog.setAttribute('aria-labelledby', successMessage.id);
    };
    const resetPending = () => {
      clearTimeout(timer);
      pending = false;
      form.setAttribute('aria-busy', 'false');
      button.removeAttribute('aria-disabled');
      button.textContent = sendLabel;
    };
    const readDraft = () => {
      try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey));
        if (draft && Date.now() - draft.time < 15 * 60 * 1000) return draft;
        sessionStorage.removeItem(storageKey);
      } catch {}
      return null;
    };
    const saveDraft = () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          time: Date.now(),
          values: Object.fromEntries(fields.map(field => [field.name, field.value]))
        }));
      } catch {}
    };
    const show = () => {
      if (dialog.open) return;
      portal.hidden = false;
      background = [...document.body.children]
        .filter(node => node !== portal && (node.contains(root) || node.matches('header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group')))
        .map(node => [node, node.inert]);
      background.forEach(([node]) => { node.inert = true; });
      document.body.classList.add('yb-contact-open');
      dialog.show();
      (dialog.dataset.state === 'success' ? successMessage : result === 'error' ? status : fields[0]).focus();
      if (dialog.dataset.state !== 'success' && !form.dataset.cptcha && window.Shopify?.captcha?.protect) {
        window.Shopify.captcha.protect(form, () => {});
      }
    };
    const close = () => {
      dialog.close();
      portal.hidden = true;
      document.body.classList.remove('yb-contact-open');
      background.forEach(([node, inert]) => { node.inert = inert; });
      background = [];
      resetSuccess();
      quote.focus();
    };
    successClose.addEventListener('click', close);
    quote.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      show();
    }, true);
    dialog.querySelector('.yb-close').addEventListener('click', event => {
      event.stopImmediatePropagation();
      close();
    }, true);
    portal.addEventListener('click', event => { if (event.target === portal) close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button, input:not([type="hidden"]), textarea, a[href], [tabindex="0"]')]
        .filter(node => !node.disabled && !node.hidden && node.getClientRects().length);
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    const beginSubmission = event => {
      if (!navigator.onLine) {
        event.preventDefault();
        event.stopImmediatePropagation();
        resetPending();
        setStatus('error', messages.offline);
        return;
      }
      if (pending) return;
      form.querySelector('input[name="return_to"]')?.remove();
      saveDraft();
      pending = true;
      form.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = messages.sending;
      setStatus('pending', messages.pending);
      timer = setTimeout(() => {
        resetPending();
        setStatus('warning', messages.waiting);
      }, 45000);
    };
    button.addEventListener('click', event => {
      if (!pending) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    window.addEventListener('submit', event => {
      if (event.target === form) beginSubmission(event);
    }, true);
    form.addEventListener('invalid', event => {
      event.preventDefault();
      resetPending();
      fields.forEach(renderFieldError);
      setStatus('warning', messages.invalid);
      fields.find(field => !field.validity.valid)?.focus();
    }, true);
    form.addEventListener('input', event => {
      if (fieldErrors.has(event.target) && event.target.hasAttribute('aria-invalid')) renderFieldError(event.target);
      if (!pending && status.dataset.state !== 'idle' && fields.every(field => field.validity.valid)) setStatus('idle', messages.ready);
    });
    window.addEventListener('offline', () => {
      if (!pending) return;
      resetPending();
      setStatus('error', messages.offline);
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted && pending) {
        resetPending();
        setStatus('warning', messages.unconfirmed);
      }
    });
    if (result === 'success') {
      try { sessionStorage.removeItem(storageKey); } catch {}
      fields.forEach(field => { field.value = ''; });
      setStatus('success', messages.success);
      showSuccess();
      show();
    } else {
      const draft = readDraft();
      if (draft) fields.forEach(field => { field.value = draft.values[field.name] || ''; });
      if (result === 'error') {
        setStatus('error', messages.error);
        show();
      } else if (draft) {
        setStatus('warning', messages.unconfirmed);
        show();
      } else {
        setStatus('idle', messages.ready);
      }
    }
  };
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
